import axios, { AxiosRequestConfig } from 'axios';
import { PagedResponse } from '../types/api';

export interface Certification {
  id: number;
  name: string;
}

const URL = '/v2/certifications';

class CertificationsService {
  static getByFilter(
    config?: AxiosRequestConfig,
  ): Promise<PagedResponse<Certification>> {
    return axios.get(URL, config);
  }
}

export { CertificationsService };
